module.exports = __webpack_public_path__ + "img/reihua-logo.6e111ff3.jpg";